/** The Statistics filter row's custom date range and recurring-hours filter. */
export const translationStatistics_sv_hours = {
  hoursFilterRecurring: "Filtrera återkommande klockslag",
  hoursFilterTimezone: "Tidszon",
  hoursFilterMondayFriday: "Måndag–fredag",
  hoursFilterEveryDay: "Varje dag",
  hoursFilterWeekendHours: "Använd andra klockslag på helgen",
  hoursFilterSaturdaySunday: "Lördag–söndag",
  hoursFilterHowHoursApply: "Så används klockslag",
  hoursFilterHowHoursApplyBody:
    "Start ingår; slut ingår inte. En tidigare sluttid går över midnatt; samma tider betyder hela dagen. Varje kalenderdag använder sitt eget intervall, även på morgonen. Samtalsstatistik använder samtalets start; livechatt följer samtalet; e-postanvändning använder avslutningstidpunkten.",
  hoursFilterCommerceUnavailable:
    "Handels- och chattöppningsmätningar är inte tillgängliga med detta samtalsfilter. Rensa filtret för att generera rapporter eller exportera; schemalagda rapporter behåller sitt eget omfång.",
  hoursFilterAllDay: "Hela dagen",
  hoursFilterFrom: "Från",
  hoursFilterUntil: "Till",
  statisticsDateRange: "Datumintervall",
  statisticsPickDateRange: "Välj datumintervall",
};
